import { ref } from "vue";

/**
 * Returns a reactive reference to a boolean value that indicates whether the specified media query matches the current viewport.
 *
 * @param {string} query - The media query to be evaluated.
 * @return {Ref<boolean>} A reactive reference to a boolean value that indicates whether the specified media query matches the current viewport.
 */
export const useMediaQuery = (query: string) => {
    const mediaRef = ref(false);
    const media = window.matchMedia(query);
    mediaRef.value = media.matches;
    media.onchange = (e) => {
        mediaRef.value = e.matches;
    };

    return mediaRef;
};
